module.exports = __webpack_public_path__ + "static/feature-tags-1-61c99a5c828ed27cfe0fd788c451ba7b.svg";